import {createAsyncThunk} from '@reduxjs/toolkit';

import {TABLE_REPORT_SLICE} from '../table-report-slice-constants';
import {ITableReportDataRequestParams} from '../table-report-slice-types';
import {searchTableReportData} from './table-report-search-api';

export const performGlobalSearch = createAsyncThunk<
    number[], ITableReportDataRequestParams
>(
    `${TABLE_REPORT_SLICE}/performGlobalSearch`,
    async (args, {rejectWithValue}) => {
        try {
            const {data: pages} = await searchTableReportData<number[]>(args);
            return pages;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);
